import * as actionTypes from './types';
import { UserState } from './types';

const initialState: UserState = {
  users: [],
  selectedUser: null,
  loading: false,
  error: null,
  success: false,
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
  },
};

const userReducer = (state = initialState, action: any): UserState => {
  switch (action.type) {
    case actionTypes.GET_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload.users,
        pagination: action.payload.pagination,
        error: null,
      };
    case actionTypes.GET_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        users: [],
      };

    case actionTypes.GET_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedUser: action.payload,
        error: null,
      };
    case actionTypes.GET_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case actionTypes.CREATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case actionTypes.CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        users: [...state.users, action.payload],
      };
    case actionTypes.CREATE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case actionTypes.UPDATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case actionTypes.UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        users: state.users.map((user) =>
          (user._id) === (action.payload._id || action.payload.id)
            ? { ...user, ...action.payload }
            : user
        ),
        selectedUser:
          state.selectedUser?._id === action.payload.id
            ? { ...state.selectedUser, ...action.payload }
            : state.selectedUser,
      };
    case actionTypes.UPDATE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case actionTypes.UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case actionTypes.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
      };
    case actionTypes.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case actionTypes.CHANGE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.CHANGE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success:true,
        error: null,
      };
    case actionTypes.CHANGE_USER_FAILURE:
      return {
        ...state,
        loading: false,    
        error: action.payload,
      };

    case actionTypes.SET_SELECTED_USER:
      return {
        ...state,
        selectedUser: action.payload,
      };

    case actionTypes.CLEAR_USER_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default userReducer;
